const ru = {
  ourTools: 'Наши инструменты',
  usedBy: 'Используется командами',
  supportedBy: 'Они поддерживают UX Core',
};
export default ru;
